import { DirectionalCell } from './directional-cell.model';

export class ShiftCell extends DirectionalCell {
    shiftBlockId: number;
}